import { useState, useEffect } from "react";
import Dialog from "@/components/Dialog";
import Button from "@/components/Button";
import Radio from "@/components/Radio";
import Banner from "@/components/Banner";

interface EditEmploymentSelectionModalProps {
  open: boolean;
  onClose(): void;
  onSelectEdit(): void;
  onSelectAdd(): void;
}

type SelectionOption = "edit" | "add";

export default function EditEmploymentSelectionModal({
  open,
  onClose,
  onSelectEdit,
  onSelectAdd
}: EditEmploymentSelectionModalProps) {
  const [selectedOption, setSelectedOption] = useState<SelectionOption>("edit");

  // Reset to default option when modal opens
  useEffect(() => {
    if (open) {
      setSelectedOption("edit");
    }
  }, [open]);

  const handleNext = () => {
    if (selectedOption === "edit") {
      onSelectEdit();
    } else {
      onSelectAdd();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClosed={onClose}
      headline="Edit Employment"
      className="sm:max-w-[600px] p-6 pr-2"
      actions={
        <>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleNext}>Next</Button>
        </>
      }
      hasFormElements
    >
      <div className="flex flex-col gap-6 py-2">
        <Banner
          description='Note: Use "Edit" to end employment, change work location, designate a role as primary, or fix errors.'
          inline
          variant="info"
        />
        <div className="flex flex-col gap-6">
          <p className="text-body-large text-sys-brand-on-surface">What do you need to do?</p>
          <div className="flex flex-col gap-4">
            <Radio
              label={
                <>
                  <strong>Edit</strong> to end role, set primary, change location, or fix errors
                </>
              }
              name="employment-action"
              id="employment-action-edit"
              checked={selectedOption === "edit"}
              onChange={(checked) => {
                if (checked) {
                  setSelectedOption("edit");
                }
              }}
            />
            <Radio
              label={
                <>
                  <strong>Add</strong> a new employment because of a job title (e.g. promotion), facility, or
                  classification change
                </>
              }
              name="employment-action"
              id="employment-action-add"
              checked={selectedOption === "add"}
              onChange={(checked) => {
                if (checked) {
                  setSelectedOption("add");
                }
              }}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
}
